import { authenticatedApiPost } from './apiWithAuth';

export interface TopicRequest {
  query: string;
}

export interface TopicResponse {
  topic: string;
  message?: string;
}

export async function generateTopic(message: string): Promise<TopicResponse> {
  try {
  
    const requestBody = { query: message };
    
    
    const response = await authenticatedApiPost('TOPIC', requestBody);

    if (!response.ok) {
      console.error('Topic API response not ok:', response.status, response.statusText);
      throw new Error(`Topic API error: ${response.status}`);
    }

    const data = await response.json();
    
    return {
      topic: data.topic || 'New Branch',
      message: data.message
    };
  } catch (error) {
    console.error('Error calling topic endpoint:', error);
    return {
      topic: 'New Branch'
    };
  }
} 